<template>
    <nav>
      <AlertMessages
        v-if="alertValue"  
        :alert-type="alertType" 
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <v-row class="content-block" style="background-color: #FFFFFF;">
        <v-col class="column pa-8">
            <v-img
                v-if="logo == null"
                data-testid="logo-space"
                src="../../assets/rtplogo.svg"
                max-height="40"
                max-width="150"
                class="d-none d-sm-block justify-center mb-5 default"
                contain
    
            />
            <v-img
                v-else
                data-testid="logo-space"
                :src="logo"
                max-height="40"
                max-width="150"
                class="d-none d-sm-block justify-center mb-5"
                position="top left"
                contain
                
            />
            <div class="mb-5">
                <p>{{ $t('labelOrganizationName')}} : {{ organizationName }}</p>
                <p>{{ $t('labelOrganizationNumber')}} : {{ organizationNumber }}</p>
                <p>{{ $t('labelAddress')}} : {{ address }}</p>
                <p>{{ $t('labelPostCode')}} : {{ postCode }}</p>
                <p>{{ $t('labelCity')}} : {{ city }}</p>
                <p>{{ $t('labelCountry')}} : {{ country }}</p>
                </div>
            <div v-html="policyText"></div>
        </v-col>
    </v-row>
    </nav>
  </template>
<script>
import { getStoreSettings } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            policyText: null,
            organizationName: '',
            organizationNumber: '',
            address: '',
            city: '',
            postCode: '',
            country: '',
        }
    },
    async created(){      
        this.loadingData = true
        await this.fetchStoreSettings()
        this.loadingData = false
    },
    methods:{
        async fetchStoreSettings() {
        try {
            const response = await getStoreSettings(this.spaceId);
            if (response.status == 200) {
                this.policyText = response.data.data.attributes.policy_text
                this.organizationName = response.data.data.attributes.organization_name
                this.organizationNumber = response.data.data.attributes.organization_number
                this.address = response.data.data.attributes.address
                this.city = response.data.data.attributes.city
                this.postCode = response.data.data.attributes.postal_code
                this.country = response.data.data.attributes.country
          }
        } catch (e) {
            if(e.response){
                if(e.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
                }
                else if(e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        }
    },
    }
}
</script>